<template>
  <span class="zg-illustration">
    <component
      :is="illustration"
      v-if="illustration"
    />
  </span>
</template>

<script>
  export default {
    name: 'ZgIllustration',
    components: {
      AccidentFridge: () => import('./illustrations/AccidentFridge.vue'),
      AccidentPlant: () => import('./illustrations/AccidentPlant.vue'),
      AggregatedOffers: () => import('./illustrations/AggregatedOffers.vue'),
      Application: () => import('./illustrations/Application.vue'),
      Blank: () => import('./illustrations/Blank.vue'),
      Budget: () => import('./illustrations/Budget.vue'),
      BusinessExpense: () => import('./illustrations/BusinessExpense.vue'),
      CarInsuranceBusiness: () => import('./illustrations/CarInsuranceBusiness.vue'),
      CarInsurancePrivate: () => import('./illustrations/CarInsurancePrivate.vue'),
      ChangeAgreement: () => import('./illustrations/ChangeAgreement.vue'),
      Celebration: () => import('./illustrations/Celebration.vue'),
      CoApplicant: () => import('./illustrations/CoApplicant.vue'),
      Comparison: () => import('./illustrations/Comparison.vue'),
      ConsolidatingLoans: () => import('./illustrations/ConsolidatingLoans.vue'),
      CreditRating: () => import('./illustrations/CreditRating.vue'),
      Education: () => import('./illustrations/Education.vue'),
      ElectricityAgreement: () => import('./illustrations/ElectricityAgreement.vue'),
      ElectricityGrid: () => import('./illustrations/ElectricityGrid.vue'),
      ExtendMortgage: () => import('./illustrations/ExtendMortgage.vue'),
      Family: () => import('./illustrations/Family.vue'),
      Fast: () => import('./illustrations/Fast.vue'),
      FinancialProtection: () => import('./illustrations/FinancialProtection.vue'),
      FindRightInsurance: () => import('./illustrations/FindRightInsurance.vue'),
      FindRightInsurance2: () => import('./illustrations/FindRightInsurance2.vue'),
      FindBestTerms: () => import('./illustrations/FindBestTerms.vue'),
      Free: () => import('./illustrations/Free.vue'),
      Globe: () => import('./illustrations/Globe.vue'),
      HealthCheck: () => import('./illustrations/HealthCheck.vue'),
      Independent: () => import('./illustrations/Independent.vue'),
      ImprovingFinances: () => import('./illustrations/ImprovingFinances.vue'),
      InsuranceTerms: () => import('./illustrations/InsuranceTerms.vue'),
      LoanBroker: () => import('./illustrations/LoanBroker.vue'),
      LoanPromise: () => import('./illustrations/LoanPromise.vue'),
      MoneyLeftEachMonth: () => import('./illustrations/MoneyLeftEachMonth.vue'),
      Mortgage: () => import('./illustrations/Mortgage.vue'),
      PayByExtendingMortgage: () => import('./illustrations/PayByExtendingMortgage.vue'),
      Payout: () => import('./illustrations/Payout.vue'),
      PeaceAndQuiet: () => import('./illustrations/PeaceAndQuiet.vue'),
      PersonalService: () => import('./illustrations/PersonalService.vue'),
      PersonWondering: () => import('./illustrations/PersonWondering.vue'),
      PowerOutage: () => import('./illustrations/PowerOutage.vue'),
      PrivateLoan: () => import('./illustrations/PrivateLoan.vue'),
      PrivateLoanCar: () => import('./illustrations/PrivateLoanCar.vue'),
      PrivateLoanMortgage: () => import('./illustrations/PrivateLoanMortgage.vue'),
      PrivateLoanMultiPurpose: () => import('./illustrations/PrivateLoanMultiPurpose.vue'),
      PrivateLoanVacation: () => import('./illustrations/PrivateLoanVacation.vue'),
      Reapply: () => import('./illustrations/Reapply.vue'),
      ReducingCosts: () => import('./illustrations/ReducingCosts.vue'),
      Renovating: () => import('./illustrations/Renovating.vue'),
      Renovation: () => import('./illustrations/Renovation.vue'),
      RightLoanAmount: () => import('./illustrations/RightLoanAmount.vue'),
      RulesLegislations: () => import('./illustrations/RulesLegislations.vue'),
      Saving: () => import('./illustrations/Saving.vue'),
      SavingLarge: () => import('./illustrations/SavingLarge.vue'),
      SelectAnOffer: () => import('./illustrations/SelectAnOffer.vue'),
      SickLeave: () => import('./illustrations/SickLeave.vue'),
      SingleCreditCheck: () => import('./illustrations/SingleCreditCheck.vue'),
      Solar: () => import('./illustrations/Solar.vue'),
      Trust: () => import('./illustrations/Trust.vue'),
      ZmartaGuidesYou: () => import('./illustrations/ZmartaGuidesYou.vue')
    },
    props: {
      illustration: {
        type: String,
        required: true,
        validator: value => [
          'accident-fridge',
          'accident-plant',
          'aggregated-offers',
          'application',
          'blank',
          'budget',
          'business-expense',
          'car-insurance-business',
          'car-insurance-private',
          'celebration',
          'change-agreement',
          'co-applicant',
          'comparison',
          'consolidating-loans',
          'credit-rating',
          'education',
          'electricity-agreement',
          'electricity-grid',
          'extend-mortgage',
          'family',
          'fast',
          'financial-protection',
          'find-best-terms',
          'find-right-insurance',
          'find-right-insurance-2',
          'free',
          'globe',
          'health-check',
          'improving-finances',
          'independent',
          'insurance-terms',
          'loan-broker',
          'loan-promise',
          'money-left-each-month',
          'mortgage',
          'pay-by-extending-mortgage',
          'payout',
          'peace-and-quiet',
          'person-wondering',
          'personal-service',
          'power-outage',
          'private-loan',
          'private-loan-car',
          'private-loan-mortgage',
          'private-loan-multi-purpose',
          'private-loan-vacation',
          'reapply',
          'reducing-costs',
          'renovating',
          'renovation',
          'right-loan-amount',
          'rules-legislations',
          'saving',
          'saving-large',
          'select-an-offer',
          'sick-leave',
          'single-credit-check',
          'solar',
          'trust',
          'zmarta-guides-you'
        ].includes(value)
      }
    }
  }
</script>

<style lang="scss" scoped>
  $colors-list:(
    black,
    white,
    beige,
    orange,
    purple,
    brown,
    "brand-500",
    "brand-300",
    "brand-100",
    "primary-500",
    "secondary-500",
    "accent-500",
    "accent-300",
    "accent-100",
  );

  .zg-illustration {
    display: inline-block;
    width: 100%;
    height: 100%;
    max-width: 100%;

    svg {
      width: auto;
      height: 100%;
      max-width: 100%;

      @each $color in $colors-list{
        ::v-deep .fill-#{"" + $color} {
          fill: color($color);
        }
      }
      @each $color in $colors-list{
        ::v-deep .stroke-#{"" + $color} {
          stroke: color($color);
        }
      }
    }
  }
</style>
